import style from "components/EventList.module.scss";
import EventListing from "components/EventListing";
import dayjs from "dayjs";
import groupBy from "lodash/groupBy";
import map from "lodash/map";
import React from "react";

const EventList = ({ events }) => {
  if (!events) return null;

  const groupedEvents = groupBy(events, (event) =>
    dayjs(event.startDateTime, "YYYY-MM-DD").startOf("month").add(1, "day")
  );

  return (
    <div className={style.root}>
      <div className={style.content}>
        <div className={style.events}>
          {map(groupedEvents, (group, key) => (
            <div key={key} className={style.group}>
              <div className={style.groupHeader}>
                <div className={style.groupHeading}>
                  {dayjs(key).format("MMMM YYYY")}
                </div>
              </div>

              <div className={style.groupEvents}>
                {group.map((event) => {
                  return (
                    <div key={event.id} className={style.eventListing}>
                      <EventListing event={event} />
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventList;
